<template>
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
    <tl-tabs :tabs="tabs" class="space margintop-32">
      <tl-tab>
        <upload-document/>
      </tl-tab>
      <tl-tab>
        <download-document/>
      </tl-tab>
    </tl-tabs>
  </div>
</template>
<script>
import downloadDocument from "./downloaddocument.vue";
import uploadDocument from "./uploaddocument.vue";
export default {
  components: {
    downloadDocument,
    uploadDocument
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Document Master",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/documentmaster`
              }
        ],
      tabs: [
        {
          header: "Upload Documents"
        },
        {
          header: "Download Documents"
        }
      ]
    };
  },
  methods: {
    routeToMainStep(main_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/${main_step_name}`
      });
    },
    routeToSubStep(sub_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/${sub_step_name}`
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/scss/components/margins.scss";  //margins
</style>

